import React, { useEffect, useRef, useState } from 'react'
import { useCurrent } from '../../hooks'
import { useTranslation } from 'react-i18next';
import { FaFilePdf, FaFileAlt, FaTimes, FaDownload } from "react-icons/fa";
import axios from 'axios';
import { toSafeHtml } from '../../utils/richTextHtml';
import { downloadAttachment, getAttachmentInfo as getSharedAttachmentInfo } from '../../utils/attachments';
import { getStatusAppearance, getStatusLabel } from '../../constants/ticket';

const KNOWN_USER_NAMES = {
    '68b68eb4eccce7fe98ce3c6f': { ar: 'محمد وجيه', en: 'Mohamed Wagih' },
    '69d61dd8ede217ea1ccddded': { ar: 'محمد وجيه', en: 'Mohamed Wagih' },
}

const getEntityId = (value) => {
    if (!value) return null;
    if (typeof value === 'string' || typeof value === 'number') return String(value);
    if (typeof value === 'object') return value?._id || value?.id || value?.userId || null;
    return null;
}

const getPersistedUserIds = () => {
    const ids = [];

    try {
        const persistedUser = JSON.parse(localStorage.getItem('user') || 'null');
        ids.push(
            persistedUser?._id,
            persistedUser?.id,
            persistedUser?.userId,
            persistedUser?.user?._id,
            persistedUser?.user?.id,
            persistedUser?.user?.userId
        );
    } catch { }

    try {
        const token = localStorage.getItem('token');
        if (token) {
            const parts = token.split('.');
            if (parts.length > 1) {
                const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
                const padded = payload + '='.repeat((4 - (payload.length % 4)) % 4);
                const data = JSON.parse(atob(padded));
                ids.push(data?._id, data?.id, data?.userId, data?.sub);
            }
        }
    } catch { }

    return ids.filter(Boolean).map(String);
}

const readPersistedUser = () => {
    try {
        return JSON.parse(localStorage.getItem('user') || 'null');
    } catch {
        return null;
    }
};

const readJwtPayload = () => {
    try {
        const token = localStorage.getItem('token');
        if (!token) return null;
        const parts = token.split('.');
        if (parts.length < 2) return null;
        const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
        const padded = payload + '='.repeat((4 - (payload.length % 4)) % 4);
        return JSON.parse(atob(padded));
    } catch {
        return null;
    }
};

const isTruthyFlag = (value) => value === true || value === 'true' || value === 1 || value === '1';

const resolveAuthValue = (user, key) => {
    const persistedUser = readPersistedUser();
    const tokenPayload = readJwtPayload();
    return (
        user?.[key] ??
        user?.user?.[key] ??
        persistedUser?.[key] ??
        persistedUser?.user?.[key] ??
        tokenPayload?.[key] ??
        tokenPayload?.user?.[key]
    );
};

const getReplyTextDirection = (value) => {
    const text = String(value || '').replace(/<[^>]*>/g, ' ');
    return /[\u0600-\u06FF]/.test(text) ? 'rtl' : 'ltr';
};

const FilePopup = ({ url, name, ext, isPdf, isImage, isVideo, previewUrl, onClose }) => {
    useEffect(() => {
        const onKey = (e) => { if (e.key === 'Escape') onClose(); };
        document.addEventListener('keydown', onKey);
        document.body.style.overflow = 'hidden';
        return () => { document.removeEventListener('keydown', onKey); document.body.style.overflow = ''; };
    }, [onClose]);

    return (
        <div onClick={onClose} style={{
            position: 'fixed', inset: 0, zIndex: 9999,
            background: 'rgba(8,12,20,0.82)', backdropFilter: 'blur(10px)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24
        }}>
            <div onClick={e => e.stopPropagation()} style={{
                background: '#fff', borderRadius: 20, overflow: 'hidden', display: 'flex', flexDirection: 'column',
                maxWidth: '92vw', maxHeight: '90vh', minWidth: 360, boxShadow: '0 32px 80px rgba(0,0,0,0.35)'
            }}>
                <div style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    padding: '14px 20px', borderBottom: '1px solid #f1f5f9', background: '#fafafa', gap: 16
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12, minWidth: 0 }}>
                        <div style={{
                            width: 38, height: 38, borderRadius: 10, flexShrink: 0,
                            background: isPdf ? '#fff1f2' : '#f0f9ff', color: isPdf ? '#ef4444' : '#0ea5e9',
                            display: 'flex', alignItems: 'center', justifyContent: 'center'
                        }}>
                            {isPdf ? <FaFilePdf size={16} /> : <FaFileAlt size={16} />}
                        </div>
                        <div style={{ minWidth: 0 }}>
                            <div style={{ fontSize: 13, fontWeight: 700, color: '#1e293b', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 300 }}>{name}</div>
                            <div style={{ fontSize: 10, color: '#94a3b8', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 1 }}>{ext} file</div>
                        </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
                        <a href={url} download={name} target="_blank" rel="noreferrer" onClick={e => { e.preventDefault(); e.stopPropagation(); downloadAttachment(url, name); }} style={{
                            display: 'flex', alignItems: 'center', gap: 6, padding: '7px 14px', borderRadius: 8,
                            background: '#0f172a', color: '#fff', fontSize: 11, fontWeight: 700, textDecoration: 'none'
                        }}>
                            <FaDownload size={9} /> تحميل
                        </a>
                        <button onClick={onClose} style={{
                            width: 32, height: 32, borderRadius: '50%', background: '#f1f5f9',
                            border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#64748b'
                        }}>
                            <FaTimes size={12} />
                        </button>
                    </div>
                </div>
                <div style={{ flex: 1, overflow: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, background: '#f8fafc', minHeight: 220 }}>
                    {isImage ? (
                        <img src={previewUrl || url} alt={name} style={{ maxWidth: '100%', maxHeight: '72vh', borderRadius: 12, boxShadow: '0 4px 24px rgba(0,0,0,0.12)', objectFit: 'contain' }} />
                    ) : isVideo ? (
                        <video
                            controls
                            playsInline
                            style={{ width: '70vw', maxWidth: 980, maxHeight: '72vh', borderRadius: 12, background: '#000', boxShadow: '0 4px 24px rgba(0,0,0,0.12)' }}
                        >
                            <source
                                src={url}
                                type={ext === 'webm' ? 'video/webm' : ext === 'ogg' ? 'video/ogg' : 'video/mp4'}
                            />
                        </video>
                    ) : isPdf ? (
                        <iframe src={url} title={name} style={{ width: '70vw', height: '72vh', minWidth: 300, border: 'none', borderRadius: 10 }} />
                    ) : (
                        <div style={{ textAlign: 'center', padding: '40px 60px' }}>
                            <div style={{ width: 72, height: 72, borderRadius: 20, background: '#f0f9ff', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
                                <FaFileAlt size={30} color="#0ea5e9" />
                            </div>
                            <p style={{ color: '#64748b', fontSize: 13, marginBottom: 12 }}>لا يمكن معاينة هذا الملف</p>
                            <a href={url} download={name} target="_blank" rel="noreferrer" onClick={e => { e.preventDefault(); downloadAttachment(url, name); }} style={{ color: '#6366f1', fontWeight: 700, fontSize: 13 }}>تحميل الملف</a>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

const normalizeAttachmentList = (attachments) => (
    Array.isArray(attachments)
        ? attachments
        : attachments
            ? [attachments]
            : []
).filter(Boolean);

const AvatarFallback = ({ src, name, style, textStyle }) => {
    const [failed, setFailed] = useState(false);
    const value = String(src || '').trim();
    const label = String(name || '?').trim();
    const initial = (label || '?').charAt(0).toUpperCase();

    useEffect(() => {
        setFailed(false);
    }, [value]);

    if (value && !failed) {
        return (
            <img
                src={value}
                alt={label}
                style={style}
                onError={() => setFailed(true)}
            />
        );
    }

    return (
        <div
            title={label}
            style={{
                ...style,
                background: '#e2e8f0',
                color: '#475569',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 800,
                ...textStyle
            }}
        >
            {initial}
        </div>
    );
};

const TicketDetailsListItem = ({ item, ticket, supportSettings, onRefresh, adminById, onRequestDelete }) => {
    const [t] = useTranslation('global');
    const { user, currentLangId } = useCurrent();
    const [popupOpen, setPopupOpen] = useState('');
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [visibilityLoading, setVisibilityLoading] = useState(false);
    const [visibilityError, setVisibilityError] = useState('');
    const createdByRaw = item?.createdBy;
    const createdById = getEntityId(createdByRaw);
    const currentUserIds = Array.from(new Set([
        getEntityId(user),
        user?.user?._id,
        user?.user?.id,
        user?.user?.userId,
        ...getPersistedUserIds()
    ].filter(Boolean).map(String)));
    const ticketOwnerId = getEntityId(ticket?.customerId) || getEntityId(ticket?.createdBy);
    const createdByLabel = (() => {
        if (!createdByRaw) return null;
        if (typeof createdByRaw === 'object') {
            return createdByRaw?.name || createdByRaw?.fullName || createdByRaw?.email || createdByRaw?._id || '';
        }
        if (createdById && currentUserIds.includes(createdById)) {
            return user?.name || user?.fullName || user?.email || createdById;
        }
        if (createdById && ticketOwnerId && createdById === ticketOwnerId) {
            return ticket?.customerName || ticket?.name || createdById;
        }
        if (item?.createdByName || item?.userName) {
            return item?.createdByName || item?.userName;
        }
        if (createdById && KNOWN_USER_NAMES[createdById]) {
            return KNOWN_USER_NAMES[createdById][currentLangId] || KNOWN_USER_NAMES[createdById].ar;
        }
        if (createdById && adminById && adminById[createdById]) {
            return adminById[createdById]?.name || createdById;
        }
        return currentLangId === 'ar' ? 'فريق الدعم الفني' : 'Support Team';
    })();

    const createdByMeta = (() => {
        if (!createdByRaw) return { avatar: '', jobTitle: '' };
        if (typeof createdByRaw === 'object') {
            return {
                avatar: String(createdByRaw?.userPic || createdByRaw?.avatar || createdByRaw?.image || ''),
                jobTitle: String(createdByRaw?.jobTitle || createdByRaw?.subLabel || '')
            };
        }
        if (createdById && currentUserIds.includes(String(createdById))) {
            return {
                avatar: String(user?.userPic || ''),
                jobTitle: String(user?.jobTitle || '')
            };
        }
        if (createdById && adminById && adminById[createdById]) {
            return {
                avatar: String(adminById[createdById]?.avatar || ''),
                jobTitle: String(adminById[createdById]?.jobTitle || '')
            };
        }
        return { avatar: '', jobTitle: '' };
    })();

    const attachmentList = normalizeAttachmentList(item?.attachments);
    const attachmentUrl = attachmentList[0] || '';
    const getAttachmentInfo = (url) => getSharedAttachmentInfo(url, item?.attachmentNames);
    const popupAttachment = getAttachmentInfo(popupOpen);
    const isImage = attachmentUrl ? getAttachmentInfo(attachmentUrl).isImage : false;
    const [previewUrl, setPreviewUrl] = useState(null);
    const objectUrlRef = useRef(null);

    useEffect(() => {
        if (objectUrlRef.current) {
            URL.revokeObjectURL(objectUrlRef.current);
            objectUrlRef.current = null;
        }
        setPreviewUrl(null);

        if (!attachmentUrl || !isImage) return;

        const controller = new AbortController();
        const token = localStorage.getItem('token');
        const headers = token ? { Authorization: `Bearer ${token}` } : undefined;

        fetch(attachmentUrl, { headers, signal: controller.signal })
            .then((res) => res.blob())
            .then((blob) => {
                const url = URL.createObjectURL(blob);
                objectUrlRef.current = url;
                setPreviewUrl(url);
            })
            .catch(() => { });

        return () => {
            controller.abort();
            if (objectUrlRef.current) {
                URL.revokeObjectURL(objectUrlRef.current);
                objectUrlRef.current = null;
            }
        };
    }, [attachmentUrl, isImage]);

    const isMe = createdById ? currentUserIds.includes(createdById) : false;
    const initials = (createdByLabel || '?').charAt(0).toUpperCase();
    const createdAtLabel = (() => {
        const date = item?.createdAt ? new Date(item.createdAt) : null;
        if (!date || Number.isNaN(date.getTime())) return '-';
        return date.toLocaleString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        });
    })();
    // الحالة اللي نزل بيها الرد (الردود القديمة قبل الميزة دي مالهاش حالة محفوظة).
    const replyStatusValue = String(item?.statusId || '').trim();
    const replyStatusLabel = replyStatusValue ? getStatusLabel(supportSettings?.statuses, replyStatusValue, currentLangId) : '';
    const replyStatusAppearance = replyStatusValue ? getStatusAppearance(supportSettings?.statuses, replyStatusValue) : null;
    const replyTextDirection = getReplyTextDirection(item?.content);
    const replyTextAlign = replyTextDirection === 'rtl' ? 'right' : 'left';
    const replyTextClassName = `mw-rich-content mw-ticket-html mw-ticket-html-${replyTextDirection}`;

    const me = {
        bubble: '#4f46e5',
        bubbleText: '#fff',
        subText: 'rgba(255,255,255,0.65)',
        attachBg: 'rgba(255,255,255,0.15)',
        attachBgHover: 'rgba(255,255,255,0.25)',
        attachBorder: 'rgba(255,255,255,0.2)',
        attachText: '#fff',
        attachSub: 'rgba(255,255,255,0.6)',
        avatar: '#3730a3',
        avatarText: '#c7d2fe',
    };
    const other = {
        bubble: '#fff',
        bubbleText: '#1e293b',
        subText: '#94a3b8',
        attachBg: '#f8fafc',
        attachBgHover: '#f1f5f9',
        attachBorder: '#e2e8f0',
        attachText: '#1e293b',
        attachSub: '#94a3b8',
        avatar: '#e2e8f0',
        avatarText: '#475569',
    };
    const c = isMe ? me : other;
    const visibilityLabel =
        String(item?.visibility || 'external').toLowerCase() === 'internal'
            ? (currentLangId === 'ar' ? 'داخلي' : 'Internal')
            : (currentLangId === 'ar' ? 'خارجي' : 'External');
    const isInternal = String(item?.visibility || 'external').toLowerCase() === 'internal';
    const authRole = resolveAuthValue(user, 'role');
    const isSupportSuperAdmin =
        isTruthyFlag(resolveAuthValue(user, 'supportAdminEnabled')) &&
        isTruthyFlag(resolveAuthValue(user, 'supportSuperAdminEnabled'));
    const canSetInternalVisibility =
        authRole === 'admin' ||
        isSupportSuperAdmin ||
        (
            isTruthyFlag(resolveAuthValue(user, 'supportAdminEnabled')) &&
            isTruthyFlag(resolveAuthValue(user, 'supportCanViewInternalTickets'))
        );
    const canUpdateDetailVisibility = Boolean(item?._id && ticket?._id && (isMe || authRole === 'admin' || isSupportSuperAdmin));
    const nextVisibility = isInternal ? 'external' : 'internal';
    const canUseVisibilityToggle = canUpdateDetailVisibility && (nextVisibility !== 'internal' || canSetInternalVisibility);
    const canDeleteAttachment = Boolean(attachmentList.length) && (isMe || user?.role === 'admin');
    // كل واحد يحذف رده، والأدمن يحذف أي رد.
    const canDeleteDetail = Boolean(item?._id) && (isMe || authRole === 'admin');

    const updateVisibility = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!canUseVisibilityToggle || visibilityLoading) return;
        setVisibilityLoading(true);
        setVisibilityError('');
        try {
            const token = localStorage.getItem('token');
            const headers = token ? { Authorization: `Bearer ${token}` } : undefined;
            const response = await axios.put(
                `${process.env.REACT_APP_SUPPORT_API_BASE_URL}/admin/${ticket._id}/details/${item._id}/visibility`,
                { visibility: nextVisibility },
                { headers, validateStatus: () => true }
            );
            if (response?.status >= 200 && response?.status < 300 && response?.data?.status === 1) {
                onRefresh?.();
                return;
            }
            setVisibilityError(response?.data?.message || (currentLangId === 'ar' ? 'فشل تغيير نوع الرد' : 'Failed to update reply type'));
        } catch {
            setVisibilityError(currentLangId === 'ar' ? 'فشل تغيير نوع الرد' : 'Failed to update reply type');
        } finally {
            setVisibilityLoading(false);
        }
    };

    const deleteAttachment = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!ticket?._id || !item?._id || !attachmentList.length) return;
        if (!canDeleteAttachment) return;
        setDeleteLoading(true);
        try {
            const token = localStorage.getItem('token');
            const headers = token ? { Authorization: `Bearer ${token}` } : undefined;

            await axios.delete(
                `${process.env.REACT_APP_UPLOADS_API_BASE_URL}/delete`,
                {
                    data: attachmentList.length > 1 ? { keyFiles: attachmentList } : { keyFile: attachmentUrl },
                    headers,
                    validateStatus: () => true
                }
            );

            await axios.delete(
                `${process.env.REACT_APP_SUPPORT_API_BASE_URL}/${ticket._id}/details/${item._id}/attachment`,
                {
                    headers,
                    validateStatus: () => true
                }
            );

            if (typeof onRefresh === 'function') {
                onRefresh();
            }
        } finally {
            setDeleteLoading(false);
        }
    };

    return (
        <>
            {popupOpen && (
                <FilePopup url={popupAttachment.url} name={popupAttachment.name} ext={popupAttachment.ext}
                    isPdf={popupAttachment.isPdf} isImage={popupAttachment.isImage} isVideo={popupAttachment.isVideo} previewUrl={popupAttachment.url === attachmentUrl ? previewUrl : null}
                    onClose={() => setPopupOpen('')} />
            )}

            <div style={{
                display: 'flex',
                justifyContent: isMe ? 'flex-end' : 'flex-start',
                marginBottom: 18,
                padding: '0 4px',
                fontFamily: "'Cairo', 'Segoe UI', sans-serif",
                direction: 'ltr'
            }}>
                <div style={{
                    display: 'flex',
                    flexDirection: isMe ? 'row-reverse' : 'row',
                    alignItems: 'flex-end',
                    gap: 10,
                    maxWidth: '82%'
                }}>
                    <AvatarFallback
                        src={createdByMeta?.avatar}
                        name={createdByLabel || initials}
                        style={{
                            width: 34,
                            height: 34,
                            borderRadius: '50%',
                            flexShrink: 0,
                            objectFit: 'cover',
                            boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
                            border: '1px solid rgba(226,232,240,0.9)',
                            marginBottom: 2
                        }}
                        textStyle={{
                            background: c.avatar,
                            color: c.avatarText,
                            fontSize: 13
                        }}
                    />

                    <div style={{
                        minWidth: 220,
                        maxWidth: 'min(72vw, 520px)',
                        borderRadius: isMe ? '18px 4px 18px 18px' : '4px 18px 18px 18px',
                        background: c.bubble,
                        border: isMe ? 'none' : '1px solid #e2e8f0',
                        boxShadow: isMe
                            ? '0 4px 16px rgba(79,70,229,0.25)'
                            : '0 2px 8px rgba(0,0,0,0.06)',
                        overflow: 'hidden',
                        direction: currentLangId === 'ar' ? 'rtl' : 'ltr'
                    }}>
                        <div style={{
                            display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16,
                            padding: '10px 14px 6px',
                            borderBottom: `1px solid ${isMe ? 'rgba(255,255,255,0.12)' : '#f1f5f9'}`
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 0 }}>
                                <div style={{ minWidth: 0 }}>
                                    <div style={{ fontSize: 12, fontWeight: 700, color: isMe ? '#c7d2fe' : '#6366f1', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        {createdByLabel}
                                    </div>
                                    {createdByMeta?.jobTitle ? (
                                        <div style={{ fontSize: 10, fontWeight: 800, color: isMe ? 'rgba(255,255,255,0.65)' : '#94a3b8', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                            {createdByMeta.jobTitle}
                                        </div>
                                    ) : null}
                                </div>
                                <span style={{
                                    fontSize: 9,
                                    fontWeight: 800,
                                    padding: '2px 8px',
                                    borderRadius: 999,
                                    background: isInternal ? (isMe ? 'rgba(255,255,255,0.18)' : '#fff7ed') : (isMe ? 'rgba(255,255,255,0.18)' : '#ecfeff'),
                                    color: isInternal ? (isMe ? '#fff' : '#9a3412') : (isMe ? '#fff' : '#155e75'),
                                    flexShrink: 0
                                }}>
                                    {visibilityLabel}
                                </span>
                                {canUseVisibilityToggle && (
                                    <button
                                        type="button"
                                        onClick={updateVisibility}
                                        disabled={visibilityLoading}
                                        style={{
                                            fontSize: 9,
                                            fontWeight: 900,
                                            padding: '2px 8px',
                                            borderRadius: 999,
                                            border: `1px solid ${isMe ? 'rgba(255,255,255,0.24)' : '#cbd5e1'}`,
                                            background: isMe ? 'rgba(255,255,255,0.14)' : '#f8fafc',
                                            color: isMe ? '#fff' : '#334155',
                                            cursor: visibilityLoading ? 'not-allowed' : 'pointer',
                                            opacity: visibilityLoading ? 0.65 : 1,
                                            flexShrink: 0
                                        }}
                                        title={currentLangId === 'ar'
                                            ? `تحويل الرد إلى ${nextVisibility === 'internal' ? 'داخلي' : 'خارجي'}`
                                            : `Change reply to ${nextVisibility}`}
                                    >
                                        {visibilityLoading
                                            ? (currentLangId === 'ar' ? 'جار...' : '...')
                                            : (currentLangId === 'ar'
                                                ? `اجعله ${nextVisibility === 'internal' ? 'داخلي' : 'خارجي'}`
                                                : `Make ${nextVisibility}`)}
                                    </button>
                                )}
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
                                {replyStatusLabel ? (
                                    <span
                                        title={currentLangId === 'ar' ? 'حالة التذكرة عند إضافة الرد' : 'Ticket status when this reply was added'}
                                        style={{
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: 5,
                                            fontSize: 10,
                                            fontWeight: 800,
                                            padding: '2px 8px',
                                            borderRadius: 999,
                                            whiteSpace: 'nowrap',
                                            background: isMe ? 'rgba(255,255,255,0.92)' : (replyStatusAppearance?.bg || '#f1f5f9'),
                                            color: replyStatusAppearance?.color || '#334155'
                                        }}
                                    >
                                        <span style={{ width: 6, height: 6, borderRadius: '50%', background: replyStatusAppearance?.dot || replyStatusAppearance?.color || '#94a3b8' }} />
                                        {replyStatusLabel}
                                    </span>
                                ) : null}
                                <span style={{ fontSize: 10, color: c.subText, whiteSpace: 'nowrap' }}>
                                    {createdAtLabel}
                                </span>
                                {canDeleteDetail && (
                                    <button
                                        type="button"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            onRequestDelete?.(item);
                                        }}
                                        style={{
                                            width: 30,
                                            height: 30,
                                            borderRadius: 999,
                                            border: `1px solid ${isMe ? 'rgba(255,255,255,0.22)' : '#fecaca'}`,
                                            background: isMe ? 'rgba(255,255,255,0.16)' : '#fff1f2',
                                            color: isMe ? '#fff' : '#ef4444',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: 'pointer'
                                        }}
                                        title={currentLangId === 'ar' ? 'حذف الرد' : 'Delete reply'}
                                    >
                                        <FaTimes size={12} />
                                    </button>
                                )}
                            </div>
                        </div>

                        <style>{`
                            .mw-ticket-html-ltr { direction: ltr; text-align: left; }
                            .mw-ticket-html-rtl { direction: rtl; text-align: right; }
                            .mw-ticket-html-ltr *,
                            .mw-ticket-html-rtl * { unicode-bidi: plaintext; }
                            .mw-ticket-html table { max-width: 100%; }
                            .mw-ticket-html ol { list-style: decimal; padding-inline-start: 20px; margin: 0; }
                            .mw-ticket-html ul { list-style: disc; padding-inline-start: 20px; margin: 0; }
                            .mw-ticket-html li { margin: 4px 0; }
                            .mw-ticket-html p { margin: 0; }
                            .mw-ticket-html a { color: ${isMe ? '#fff' : '#4f46e5'}; text-decoration: underline; }
                        `}</style>
                        <div
                            className={replyTextClassName}
                            dir={replyTextDirection}
                            style={{ padding: '10px 14px', fontSize: 13, lineHeight: 1.75, color: c.bubbleText, direction: replyTextDirection, textAlign: replyTextAlign, unicodeBidi: 'plaintext' }}
                            dangerouslySetInnerHTML={{ __html: toSafeHtml(item.content) }}
                        />
                        {visibilityError ? (
                            <div style={{
                                padding: '0 14px 10px',
                                fontSize: 10,
                                fontWeight: 800,
                                color: isMe ? '#fecaca' : '#dc2626'
                            }}>
                                {visibilityError}
                            </div>
                        ) : null}

                        {!!attachmentList.length && (
                            <div style={{ padding: '0 10px 10px' }}>
                                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, flex: 1, minWidth: 0 }}>
                                        {attachmentList.map((url) => {
                                            const info = getAttachmentInfo(url);
                                            return (
                                                <button
                                                    key={url}
                                                    onClick={() => setPopupOpen(url)}
                                                    style={{
                                                        display: 'flex', alignItems: 'center', gap: 10,
                                                        padding: '9px 12px', borderRadius: 10, width: '100%',
                                                        background: c.attachBg, border: `1px solid ${c.attachBorder}`,
                                                        cursor: 'pointer', textAlign: 'right', transition: 'background .15s'
                                                    }}
                                                    onMouseEnter={e => e.currentTarget.style.background = c.attachBgHover}
                                                    onMouseLeave={e => e.currentTarget.style.background = c.attachBg}
                                                >
                                                    {info.isImage ? (
                                                        <img src={url === attachmentUrl ? (previewUrl || url) : url} alt={info.name}
                                                            style={{ width: 38, height: 38, objectFit: 'cover', borderRadius: 7, flexShrink: 0 }} />
                                                    ) : (
                                                        <div style={{
                                                            width: 34, height: 34, borderRadius: 8, flexShrink: 0,
                                                            background: info.isPdf ? (isMe ? 'rgba(239,68,68,0.2)' : '#fff1f2') : (isMe ? 'rgba(14,165,233,0.2)' : '#f0f9ff'),
                                                            color: info.isPdf ? '#ef4444' : '#0ea5e9',
                                                            display: 'flex', alignItems: 'center', justifyContent: 'center'
                                                        }}>
                                                            {info.isPdf ? <FaFilePdf size={14} /> : <FaFileAlt size={14} />}
                                                        </div>
                                                    )}
                                                    <div style={{ flex: 1, minWidth: 0 }}>
                                                        <div style={{ fontSize: 12, fontWeight: 700, color: c.attachText, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                            {info.name}
                                                        </div>
                                                        <div style={{ fontSize: 9, color: c.attachSub, fontWeight: 600, textTransform: 'uppercase', marginTop: 2, letterSpacing: 0.5 }}>
                                                            {info.ext} · {t('support.tickets.attachments')}
                                                        </div>
                                                    </div>
                                                </button>
                                            );
                                        })}
                                    </div>
                                    {canDeleteAttachment && (
                                        <button
                                            type="button"
                                            onClick={deleteAttachment}
                                            disabled={deleteLoading}
                                            style={{
                                                width: 34,
                                                height: 34,
                                                borderRadius: 999,
                                                border: `1px solid ${isMe ? 'rgba(255,255,255,0.22)' : '#fecaca'}`,
                                                background: isMe ? 'rgba(255,255,255,0.16)' : '#fff1f2',
                                                color: isMe ? '#fff' : '#ef4444',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                cursor: deleteLoading ? 'not-allowed' : 'pointer',
                                                opacity: deleteLoading ? 0.6 : 1
                                            }}
                                        >
                                            <FaTimes size={12} />
                                        </button>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}

export default TicketDetailsListItem
